import { render, staticRenderFns } from "./view-offer.vue?vue&type=template&id=6cbe53ec&scoped=true&"
import script from "./view-offer.vue?vue&type=script&lang=js&"
export * from "./view-offer.vue?vue&type=script&lang=js&"
import style0 from "./view-offer.vue?vue&type=style&index=0&id=6cbe53ec&lang=scss&scoped=true&"
import style1 from "./view-offer.vue?vue&type=style&index=1&id=6cbe53ec&lang=scss&scoped=true&"
import style2 from "./view-offer.vue?vue&type=style&index=2&id=6cbe53ec&lang=scss&scoped=true&"
import style3 from "./view-offer.vue?vue&type=style&index=3&lang=scss&"
import style4 from "./view-offer.vue?vue&type=style&index=4&id=6cbe53ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe53ec",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QItem,QItemSection,QAvatar,QImg,QItemLabel,QBtn,QSpinnerIos,QTabs,QTab,QTabPanel,QTabPanels,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QItem,QItemSection,QAvatar,QImg,QItemLabel,QBtn,QSpinnerIos,QTabs,QTab,QTabPanel,QTabPanels})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
